import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_b4nk-studio/artifacts/ob8a8fa3_logo.jpeg";

const links = [
    { id: "portfolio", label: "Work" },
    { id: "about", label: "Artist" },
    { id: "services", label: "Pricing" },
    { id: "reviews", label: "Reviews" },
    { id: "booking", label: "Book" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
                <button
                    data-testid="navbar-logo"
                    onClick={() => go("hero")}
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO}
                        alt="TATZBYB4NK"
                        className="h-10 w-10 md:h-12 md:w-12 object-cover border border-[#7CFC00]/40 group-hover:border-[#7CFC00] transition-colors"
                    />
                    <span className="font-display text-xl md:text-2xl tracking-wider text-white group-hover:text-[#7CFC00] transition-colors">
                        TATZ<span className="text-[#7CFC00]">BY</span>B4NK
                    </span>
                </button>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="text-sm uppercase tracking-[0.2em] text-zinc-300 hover:text-[#7CFC00] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-book-btn"
                        onClick={() => go("booking")}
                        className="bg-[#7CFC00] text-black font-semibold uppercase tracking-widest text-xs px-5 py-3 hover:bg-[#65E000] transition-colors glow-neon"
                    >
                        Book Now
                    </button>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="md:hidden text-white p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
                >
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`mobile-nav-${l.id}`}
                                onClick={() => go(l.id)}
                                className="text-left text-base uppercase tracking-widest text-zinc-200 hover:text-[#7CFC00] py-2 border-b border-white/5"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="mobile-book-btn"
                            onClick={() => go("booking")}
                            className="bg-[#7CFC00] text-black font-semibold uppercase tracking-widest text-sm px-5 py-3 mt-2 glow-neon"
                        >
                            Book Now
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};
